import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthApiV2Module } from './auth/auth-api-v2.module';
import { TaskFileGroupsModule } from './task-file-groups/task-file-groups.module';

@NgModule({
  imports: [CommonModule],
  exports: [
    AuthApiV2Module,
    TaskFileGroupsModule
  ],
})
export class RestModule {}
